import { defineFcm } from '../shared/factory';

export const FCM_SUBSCRIPTION_COUNTRY_STAFF_COUNT = defineFcm('subscription_country_staff_count')
	.asNumber()
	.withDefault(0)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'PSF Membership Ask',
		description: 'This FC is used on membership-ask pages to display staff count',
		import: false,
	});
